module.exports = __webpack_public_path__ + "img/online.95cec45d.jpg";